import {
  Box, FormControlLabel, Stack, Switch, Typography,
} from '@mui/material';
import { isNil } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import CustomTextField from '../../../components/CustomTextField';
import { useGetAccountPlanDefinitions } from '../../../hooks/query/useAccounts';
import STRING_KEYS from '../../../language/keys';
import { AccountAssociatedFields } from '../AccountEditPanelContainer';
import { style } from '../AccountInformationSection/style';
import { accountCreditsAndSeatsStyle } from './account-credits-and-seats.style';

type AccountSeatsProps = {
  viewMode: ViewMode;
  pricingPlan: string;
  accountAssociatedFields: AccountAssociatedFields;
  onValuesChange: (name: string, value: string) => void;
};
export const AccountCreditsAndSeats = ({
  viewMode,
  pricingPlan,
  accountAssociatedFields,
  onValuesChange,
}: AccountSeatsProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const { data: planDefinitions = [] } = useGetAccountPlanDefinitions();

  const isInEditMode = viewMode === 'editable';
  const planDefinition = planDefinitions.find((plan) => plan.pricingPlan === pricingPlan);

  return (
    <Box>
      <Typography variant="h6" sx={ accountCreditsAndSeatsStyle.Typography.sx }>
        {translate(STRING_KEYS.USER_SEATS_TITLE)}
      </Typography>

      <Stack direction="column" spacing="16px">
        <Stack direction="row" spacing="16px">
          <CustomTextField
            viewMode={ viewMode }
            label={ `User Seats ${
              isNil(planDefinition?.userSeatsPlanLimit) ?
                '' :
                `(Plan limit: ${accountAssociatedFields?.userSeatsPlanLimit})`
            }` }
            variant="outlined"
            value={
              isNil(planDefinition?.userSeatsPlanLimit) ?
                'Unlimited' :
                accountAssociatedFields?.maxUserSeats.value
            }
            error={ accountAssociatedFields?.maxUserSeats?.error }
            helperText={ accountAssociatedFields?.maxUserSeats?.helperText }
            name="maxUserSeats"
            InputLabelProps={ style.label }
            disabled={ isNil(planDefinition?.userSeatsPlanLimit)  }
            onChange={ (e) => {
              onValuesChange('maxUserSeats', e.target.value);
            } }
          />
            
          {isInEditMode ? (
            <CustomTextField
              viewMode={ viewMode }
              label="Add Credits"
              variant="outlined"
              value={ accountAssociatedFields.addCredits?.value }
              error={ accountAssociatedFields.addCredits?.error }
              helperText={ accountAssociatedFields?.addCredits?.helperText }
              name="addCredits"
              InputLabelProps={ style.label }
              onChange={ (e) => {
                onValuesChange('addCredits', e.target.value);
              } }
            />
          ) : (
            <CustomTextField
              viewMode={ viewMode }
              label="Credits"
              variant="outlined"
              value={ `Used ${accountAssociatedFields?.creditsUsed} / ${accountAssociatedFields?.totalCredits}` }
              InputLabelProps={ style.label }
            />
          )}
        </Stack>

        <FormControlLabel
          disabled={ viewMode !== 'editable' }
          control={ (
            <Switch
              onChange={ (e) => {
                onValuesChange('isCreditsBased', e.target.checked.toString());
              } }
              checked={
                accountAssociatedFields?.isCreditsBased?.value === 'true'
              }
            />
          ) }
          label="Plan is credits based"
        />
      </Stack>
    </Box>
  );
};
